import React, { useState } from 'react'
import FormSkel from './FormSkel'

export default ({ clientData, handleSubmit, handleClose, us = [] }) => {
  const [ownerIds, setOwnerIds] = useState([0])
  const [kodUsSearch, setKodUsSearch] = useState(null)
  const kodUsName = item => `${item.Nazwa} [${item.KodUs ?? item.KodUS}]`
  const currentKodUs = kodUsSearch === null ? (us.find(item => String(item.KodUs ?? item.KodUS) === String(clientData?.KodUS)) ? kodUsName(us.find(item => String(item.KodUs ?? item.KodUS) === String(clientData?.KodUS))) : String(clientData?.KodUS || '')) : kodUsSearch
  const selectedUS = us.find(item => currentKodUs === kodUsName(item) || currentKodUs === String(item.KodUs ?? item.KodUS))
  const kodUsValue = selectedUS ? String(selectedUS.KodUs ?? selectedUS.KodUS) : (kodUsSearch === null ? String(clientData?.KodUS || '') : '')

  return (
    <FormSkel
      headerText={clientData ? 'Edycja klienta' : 'Dodaj klienta'}
      handleClose={handleClose}
    >
      <form onSubmit={handleSubmit} id="modal-form" autoComplete="off" style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 4 }}>
        <input type="hidden" name="oldName" value={clientData?.Abbreviation || ''} readOnly />

        <h6 className="border-bottom pb-1 mb-2">Dane podstawowe</h6>
        <div className="row mx-n1">
          <div className="form-group col-md-8 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Nazwa klienta</label>
            <input name="name" className="form-control form-control-sm" defaultValue={clientData?.Name || ''} maxLength={150} required />
          </div>
          <div className="form-group col-md-4 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Skrót bazy (3 litery)</label>
            <input name="abbreviation" className="form-control form-control-sm" defaultValue={clientData?.Abbreviation || ''} readOnly={!!clientData} maxLength={3} required />
          </div>
          {!clientData && (
            <div className="form-group col-12 px-1 mb-2">
              <label className="small font-weight-bold mb-1">E-maile właścicieli</label>
              {ownerIds.map((id, index) => (
                <div className="d-flex align-items-center mb-1" key={id} style={{ gap: 6 }}>
                  <input name="ownermail" type="email" className="form-control form-control-sm" maxLength={100} defaultValue="" required placeholder={`E-mail właściciela ${index + 1}`} />
                  {ownerIds.length > 1 && <button type="button" className="btn btn-outline-danger btn-sm" title="Usuń e-mail" onClick={() => setOwnerIds(prev => prev.filter(item => item !== id))}><i className="fas fa-trash" /></button>}
                </div>
              ))}
              <button type="button" className="btn btn-link btn-sm p-0 mt-1" disabled={ownerIds.length >= 20} onClick={() => setOwnerIds(prev => [...prev, Math.max(...prev) + 1])}><i className="fas fa-plus mr-1" />Dodaj e-mail</button>
            </div>
          )}
        </div>

        <div className="small text-muted mb-2">Pozostałe dane firmy i adresu są opcjonalne.</div>
        <h6 className="border-bottom pb-1 mt-2 mb-2">Dane firmy</h6>
        <div className="row mx-n1">
          <div className="form-group col-md-8 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Pełna nazwa podmiotu</label>
            <input name="NazwaPod" className="form-control form-control-sm" defaultValue={clientData?.NazwaPod || ''} maxLength={256} />
          </div>
          <div className="form-group col-md-4 px-1 mb-2">
            <label className="small font-weight-bold mb-1">NIP</label>
            <input name="NIP" type="text" className="form-control form-control-sm" defaultValue={clientData?.NIP || ''} maxLength={10} pattern="[0-9]{10}" inputMode="numeric" onInput={e => { e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '').slice(0, 10) }} />
          </div>
          <div className="form-group col-12 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Urząd skarbowy</label>
            <input name="KodUSSearch" list="client-tax-offices" className="form-control form-control-sm" value={currentKodUs} placeholder="Wpisz nazwę lub kod urzędu" autoComplete="off" onChange={e => { const value = e.target.value; setKodUsSearch(value); e.target.setCustomValidity(value && !us.some(item => value === kodUsName(item) || value === String(item.KodUs ?? item.KodUS)) ? 'Wybierz urząd z listy' : '') }} />
            <input type="hidden" name="KodUS" value={kodUsValue} readOnly />
            <datalist id="client-tax-offices">
              {us.map(item => <option key={item.KodUs ?? item.KodUS} value={kodUsName(item)} />)}
            </datalist>
          </div>
        </div>

        <h6 className="border-bottom pb-1 mt-2 mb-2">Adres firmy</h6>
        <div className="row mx-n1">
          <div className="form-group col-md-6 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Ulica</label>
            <input name="AdresPod_ulica" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_ulica || ''} maxLength={70} />
          </div>
          <div className="form-group col-6 col-md-3 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Nr domu</label>
            <input name="AdresPod_nrDomu" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_nrDomu || ''} maxLength={15} />
          </div>
          <div className="form-group col-6 col-md-3 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Nr lokalu</label>
            <input name="AdresPod_nrLok" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_nrLok || ''} maxLength={15} />
          </div>
          <div className="form-group col-md-5 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Miejscowość</label>
            <input name="AdresPod_miejsc" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_miejsc || ''} maxLength={70} />
          </div>
          <div className="form-group col-5 col-md-3 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Kod pocztowy</label>
            <input name="AdresPod_kodPoczt" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_kodPoczt || ''} maxLength={6} inputMode="numeric" pattern="[0-9]{2}-[0-9]{3}" placeholder="00-000" onInput={e => { const digits = e.currentTarget.value.replace(/\D/g, '').slice(0, 5); e.currentTarget.value = digits.length >= 2 && !(digits.length === 2 && e.nativeEvent?.inputType?.startsWith('delete')) ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits }} />
          </div>
          <div className="form-group col-7 col-md-4 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Poczta</label>
            <input name="AdresPod_poczta" className="form-control form-control-sm" defaultValue={clientData?.AdresPod_poczta || ''} maxLength={70} />
          </div>
        </div>

        <h6 className="border-bottom pb-1 mt-2 mb-2">Rozliczenia</h6>
        <div className="row mx-n1">
          <div className="form-group col-md-6 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Numer rachunku bankowego</label>
            <input name="BankAccount" className="form-control form-control-sm" defaultValue={clientData?.BankAccount || ''} maxLength={35} pattern="[0-9 ]{26,35}" />
          </div>
          <div className="form-group col-md-6 px-1 mb-2">
            <label className="small font-weight-bold mb-1">E-mail do faktur</label>
            <input name="InvoiceEmail" type="email" className="form-control form-control-sm" defaultValue={clientData?.InvoiceEmail || ''} maxLength={255} />
          </div>
        </div>

        <div className="form-group mb-1 mt-2">
          <label className="small mb-0">
            <input
              name="RegulaminZgoda"
              type="checkbox"
              className="mr-2"
              defaultChecked={clientData?.RegulaminZgoda == null ? true : !!Number(clientData.RegulaminZgoda?.data?.[0] ?? clientData.RegulaminZgoda)}
            />
            Zgoda na regulamin
          </label>
        </div>
      </form>
    </FormSkel>
  )
}
